
// SVG Icon: download
export default { id: "terriajs-download" };
export const id = "terriajs-download";
export const name = "download";
